<section
	*ngIf="!hide"
	class="sec-container sec-aux-content transition padding--zero"
>
	<div *ngIf="isLoading" class="center">
		<freud-loader size="sm" [bgColor]="false"></freud-loader>
	</div>
	<div *ngIf="!isLoading" class="row profile-completion--container">
		<div
			class="profile-completion--error-wrapper center"
			*ngIf="requestCompletionStatusError"
		>
			<h1>{{ this.requestCompletionStatusError }}</h1>
		</div>

		<div *ngIf="!requestCompletionStatusError" class="profile-completion--body">
			<!--  Sessions Init -->

			<div *ngIf="!hideSection">
				<app-profile-completion-section
					*ngFor="let section of data; let i = index"
					[index]="i"
					[type]="section.type"
					[title]="section.title"
					[subtitle]="section.subtitle"
					[hideDivider]="i === data.length - 1"
					[todos]="section.payload"
					[hasBtn]="i === 2"
					[status]="section.status"
					[isUserActive]="isUserActive"
					[reset]="reset"
				>
				</app-profile-completion-section>
			</div>
		</div>
	</div>
</section>
